import React, { useEffect, useState } from "react";
import Card from './Card'
import { BASE_URL } from "../../../Components/Base_url/Base_Url";
// import GlobalSlider from "../../../../Helper/Globel_slider/Globel_Slider";
import Loader from "../../../Components/Base_url/Loader";
function Our_Tour({ services, loading, Message, sectionParagraph }) {


    return (
        <div className="container-fluid service pb-5 py-5">
            <div className="container pb-5">
                {/* Section Heading */}
                <div
                    className="text-center mx-auto pb-5 wow fadeInUp"
                    data-wow-delay="0.2s"
                    style={{ maxWidth: 800 }}
                >
                    <h4 className="text-primary">Lets Go With Us!</h4>

                    <h1 className="display-5 mb-4">{Message}</h1>

                    {/* <p className="mb-0">
            Call For Cab offering you best tour packages from Jaipur to given
            destination, enjoy your ride.
          </p> */}
                    <p
                        className="mb-0"
                        dangerouslySetInnerHTML={{ __html: sectionParagraph }}
                    ></p>
                    


                </div>



                {/* Service Cards */}
                <div className="container">
                    {loading && <Loader show={loading} />}

                    {/* {(services || []).map((service, index) => ( */}
                    <Card key={services.Service_id} service={services} />
                    {/* ))} */}



                </div>
            </div>
        </div>
    );
}

export default Our_Tour;
